import { render } from "./PurchaseDetails.vue?vue&type=template&id=39f8d746&scoped=true&ts=true"
import script from "./PurchaseDetails.vue?vue&type=script&lang=ts"
export * from "./PurchaseDetails.vue?vue&type=script&lang=ts"

import "./PurchaseDetails.vue?vue&type=style&index=0&id=39f8d746&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f8d746"]])

export default __exports__